import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VisaService } from 'src/app/business-service/visa/visa.service';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';
import { InputValidationsService } from 'src/app/modules/shared/services/validations/input-validations.service';

@Component({
  selector: 'app-visa-important-information',
  templateUrl: './important-information.component.html',
  styleUrls: ['./important-information.component.scss'],
})
export class ImportantInformationComponent implements OnInit {

  @Input() visaId: any;
  @Input() leadId: any;
  @Input() storedFormData: any;
  @Input() editVisaId: any;

  @Input() visaLeadInfo:any;

  @Output() viewChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() storeFormData: EventEmitter<any> = new EventEmitter<any>();

  importantInformationForm!: FormGroup;

  // TODO: use LOV here

  visaTypes: any = [
    {
      name: 'Tourist Visa',
      key: 'Tourist Visa'
    },
    {
      name: 'Business Visa',
      key: 'Business Visa'
    },
    {
      name: 'Student Visa',
      key: 'Student Visa'
    },
    {
      name: 'Transit Visa',
      key: 'Transit Visa'
    },
    {
      name: 'Work Visa',
      key: 'Work Visa'
    },
    {
      name: 'Family Visa',
      key: 'Family Visa'
    },
    {
      name: 'PR Visa',
      key: 'PR Visa'
    }
  ]

  applicantTypes: any = [
    {
      name: 'Retired',
      key: 'Retired'
    },
    {
      name: 'Employee',
      key: 'Employee'
    },
    {
      name: 'Self Employed',
      key: 'Self Employed'
    },
    {
      name: 'Student',
      key: 'Student'
    }
  ]

  constructor(
    private _globalService: GlobalService,
    private _fb: FormBuilder,
    private _visaService: VisaService,
    private _responseNotificationService: ResponseNotificationService,
    private _validationService: InputValidationsService
  ) { }

  ngOnInit() {    
    this.importantInformationForm = this._fb.group({
      visaId: this.visaId,
      leadId: this.leadId,
      mandatoryDocuments: this._fb.group({
        data: this._fb.array([])
      }),
      documentsBasedOnVisa: this._fb.group({
        data: this._fb.array([])
      }),
      otherDocuments: this._fb.group({
        data: this._fb.array([])
      }),
      keyPoints: this._fb.group({
        data: this._fb.array([])
      }),
      restrictedItems: this._fb.group({
        data: this._fb.array([])
      }),
      importantNotes: this._fb.group({
        data: this._fb.array([])
      }),
      detailsAboutStay: this._fb.group({
        data: this._fb.array([])
      }),
      status: [''],
      countryId: [null],
      id: [null],
      ownershipRole: [''],
      ownership: [''],
      createdBy: [''],
      createDate: [''],
      organizationId: [null]
    });

    this.importantInformationForm.valueChanges.subscribe(()=>{
      this.importantInformationForm.markAsTouched();
      this.importantInformationForm.markAsDirty();
    })

    if(this.storedFormData){
      this.patchVisaImportantInformation(this.storedFormData);
    }else{
      if(this.visaLeadInfo){
        let country = this.visaLeadInfo.destination;
        let visaTypesOfPassengers = this.visaLeadInfo.passengerInfo?.map((item:any)=> item.visaType)
        let applicantTypesOfPassengers = this.visaLeadInfo.passengerInfo?.map((item:any)=> item.applicantType)

        let data :any = {
          countryName: country,
          visaTypes: visaTypesOfPassengers,
          applicantTypes: applicantTypesOfPassengers
        }
        this._visaService.getCountryDetailsForVisaLead(data).subscribe((res)=>{
          this.patchVisaImportantInformation(this.deleteAuditData(res));
        })
               
      }      
    }
  }

  deleteAuditData(object: any) {
    let newObject = { ...object };

    delete newObject.leadId;
    delete newObject.visaId;
    delete newObject.category;
    delete newObject.createDate;
    delete newObject.createdBy;
    delete newObject.id;
    delete newObject.isDeleted;
    delete newObject.modifiedBy;
    delete newObject.modifiedDate;
    delete newObject.section;
    delete newObject.status;
    delete newObject.organizationId;
    delete newObject.ownership;
    delete newObject.ownershipRole;

    return newObject;
  }

  // Reactive form funtions

  // Documetns form array

  mandatoryDocumentsArray(): FormArray {
    return this.importantInformationForm.get('mandatoryDocuments.data') as FormArray;
  }

  documentsBasedOnVisaType(): FormArray {
    return this.importantInformationForm.get('documentsBasedOnVisa.data') as FormArray;
  }

  otherDocumentsArray(): FormArray {
    return this.importantInformationForm.get('otherDocuments.data') as FormArray;
  }

  keyPointsToNoteArray(): FormArray {
    return this.importantInformationForm.get('keyPoints.data') as FormArray;
  }

  prohibitedOrRestrictedItemsArray(): FormArray {
    return this.importantInformationForm.get('restrictedItems.data') as FormArray;
  }

  importantNotesArray(): FormArray {
    return this.importantInformationForm.get('importantNotes.data') as FormArray;
  }

  detailsAboutStayArray(): FormArray {
    return this.importantInformationForm.get('detailsAboutStay.data') as FormArray;
  }

  // Add and remove document funtions
  addMandatoryDocument() {
    this.mandatoryDocumentsArray().push(this.createDocumentItem());
  }

  removeMandatoryDocument(index: number) {
    this.mandatoryDocumentsArray().removeAt(index);
  }

  addDocumentsBasedOnVisaType() {
    this.documentsBasedOnVisaType().push(this.createDocumentItemForVisaType());
  }

  removeDocumentsBasedOnVisaType(index: number) {
    this.documentsBasedOnVisaType().removeAt(index);
  }

  addOtherDocument() {
    this.otherDocumentsArray().push(this.createDocumentItem());
  }

  removeOtherDocument(index: number) {
    this.otherDocumentsArray().removeAt(index);
  }

  addKeyPointsToNote() {
    this.keyPointsToNoteArray().push(this.createDocumentItem());
  }

  removeKeyPointsToNote(index: number) {
    this.keyPointsToNoteArray().removeAt(index);
  }

  addProhibitedOrRestrictedItems() {
    this.prohibitedOrRestrictedItemsArray().push(this.createDocumentItem());
  }

  removeProhibitedOrRestrictedItems(index: number) {
    this.prohibitedOrRestrictedItemsArray().removeAt(index);
  }

  addImportantNotes() {
    this.importantNotesArray().push(this.createDocumentItem());
  }

  removeImportantNotes(index: number) {
    this.importantNotesArray().removeAt(index);
  }

  addDetailsAboutStay() {
    this.detailsAboutStayArray().push(this.createDocumentItem());
  }

  removeDetailsAboutStay(index: number) {
    this.detailsAboutStayArray().removeAt(index);
  }


  createDocumentItem(): FormGroup {
    let group = this._fb.group({
      name: ['', [Validators.required]],
      note: [''],
      isDocumentRequired: [true, [Validators.required]]
    })
    return group;
  }

  createDocumentItemForVisaType(): FormGroup {
    let group = this._fb.group({
      name: ['', [Validators.required]],
      note: [''],
      visaTypes: [[], [Validators.required, this._validationService.arrayNotEmptyValidator()]],
      applicantTypes: [[], [Validators.required, this._validationService.arrayNotEmptyValidator()]],
      isDocumentRequired: [true, [Validators.required]]
    })
    return group;
  }

  // Visa type selections
  toggleSelectAllVisaType(event: any, index: number) {
    let selectAll = event?.target?.checked;
    let visaType = this.documentsBasedOnVisaType().at(index).get('visaTypes');
    if (selectAll) {
      visaType?.setValue(this.visaTypes.map((item: any) => item.key));
    } else {
      visaType?.setValue([]);
    }
    visaType?.markAsTouched();
  }

  checkAllVisaSelected(index: number) {
    let visaType = this.documentsBasedOnVisaType().at(index).get('visaTypes');
    return visaType?.value?.length === this.visaTypes?.length;
  }

  toggleVisaType(event: any, index: number, value: any) {
    let visaType = this.documentsBasedOnVisaType().at(index).get('visaTypes');
    let selectedVisas = visaType?.value;

    if (event?.target?.checked) {
      selectedVisas.push(value);
      visaType?.setValue(selectedVisas)
    } else {
      let index = selectedVisas.indexOf(value);
      selectedVisas.splice(index, 1);
      visaType?.setValue(selectedVisas);
    }
    visaType?.markAsTouched();
  }

  checkVisaTypeSelected(index: number, value: any) {
    let visaType = this.documentsBasedOnVisaType().at(index).get('visaTypes');
    return visaType?.value.includes(value);
  }

  // Applicant type selection
  toggleSelectAllApplicantType(event: any, index: number) {
    let selectAll = event?.target?.checked;
    let applicantType = this.documentsBasedOnVisaType().at(index).get('applicantTypes');
    if (selectAll) {
      applicantType?.setValue(this.applicantTypes.map((item: any) => item.key));
    } else {
      applicantType?.setValue([]);
    }
    applicantType?.markAsTouched();
  }

  checkAllApplicantTypeSelected(index: number) {
    let applicantType = this.documentsBasedOnVisaType().at(index).get('applicantTypes');
    return applicantType?.value?.length === this.applicantTypes?.length;
  }

  toggleApplicantType(event: any, index: number, value: any) {
    let applicantType = this.documentsBasedOnVisaType().at(index).get('applicantTypes');
    let selectedApplicantTypes = applicantType?.value;

    if (event?.target?.checked) {
      selectedApplicantTypes.push(value);
      applicantType?.setValue(selectedApplicantTypes)
    } else {
      let index = selectedApplicantTypes.indexOf(value);
      selectedApplicantTypes.splice(index, 1);
      applicantType?.setValue(selectedApplicantTypes);
    }
    applicantType?.markAsTouched();
  }

  checkApplicantTypeSelected(index: number, value: any) {
    let applicantType = this.documentsBasedOnVisaType().at(index).get('applicantTypes');
    return applicantType?.value.includes(value);
  }

  // Funtion to check invalid control in array
  checkInvalidControlInArray(array:FormArray, index: number, control: string): boolean | undefined{
    return array.at(index).get(control)?.invalid && array.at(index).get(control)?.touched
  }

  // Patching visa important information
  patchVisaImportantInformation(formData:any){
    this.importantInformationForm.patchValue(formData);

    if(formData.mandatoryDocuments?.data?.length > 0){
      this.mandatoryDocumentsArray().clear();
      formData.mandatoryDocuments.data.forEach((item:any, index:number) => {
        let group = this.createDocumentItem();
        if(!this.storedFormData){
          item = this.removeDocumentRequiredProperty(item);
        }
        group.patchValue(item);
        this.mandatoryDocumentsArray().push(group);
      });
    }
    
    if(formData.documentsBasedOnVisa?.data?.length > 0){
      this.documentsBasedOnVisaType().clear();
      formData.documentsBasedOnVisa.data.forEach((item:any, index:number) => {
        let group = this.createDocumentItemForVisaType();
        if(!this.storedFormData){
          item = this.removeDocumentRequiredProperty(item);
        }
        group.patchValue(item);
        this.documentsBasedOnVisaType().push(group);
      });
    }

    if(formData.otherDocuments?.data?.length > 0){
      this.otherDocumentsArray().clear();
      formData.otherDocuments.data.forEach((item:any, index:number) => {
        let group = this.createDocumentItem();
        if(!this.storedFormData){
          item = this.removeDocumentRequiredProperty(item);
        }
        group.patchValue(item);
        this.otherDocumentsArray().push(group);
      });
    }

    if(formData.keyPoints?.data?.length > 0){
      this.keyPointsToNoteArray().clear();
      formData.keyPoints.data.forEach((item:any, index:number) => {
        let group = this.createDocumentItem();
        if(!this.storedFormData){
          item = this.removeDocumentRequiredProperty(item);
        }
        group.patchValue(item);
        this.keyPointsToNoteArray().push(group);
      });
    }

    if(formData.restrictedItems?.data?.length > 0){
      this.prohibitedOrRestrictedItemsArray().clear();
      formData.restrictedItems.data.forEach((item:any, index:number) => {
        let group = this.createDocumentItem();
        if(!this.storedFormData){
          item = this.removeDocumentRequiredProperty(item);
        }
        group.patchValue(item);
        this.prohibitedOrRestrictedItemsArray().push(group);
      });
    }

    if(formData.importantNotes?.data?.length > 0){
      this.importantNotesArray().clear();
      formData.importantNotes.data.forEach((item:any, index:number) => {
        let group = this.createDocumentItem();
        if(!this.storedFormData){
          item = this.removeDocumentRequiredProperty(item);
        }
        group.patchValue(item);
        this.importantNotesArray().push(group);
      });
    }

    if(formData.detailsAboutStay?.data?.length > 0){
      this.detailsAboutStayArray().clear();
      formData.detailsAboutStay.data.forEach((item:any, index:number) => {
        let group = this.createDocumentItem();
        if(!this.storedFormData){
          item = this.removeDocumentRequiredProperty(item);
        }
        group.patchValue(item);
        this.detailsAboutStayArray().push(group);
      });
    }

    this.importantInformationForm.markAsPristine();
  }
  
  // Helper functions

  removeDocumentRequiredProperty(data:any){
    delete data.isDocumentRequired;
    return data;
  }

  async onSubmit(): Promise<boolean> {
    if(this.importantInformationForm.valid){
      try {
        const formData = this.importantInformationForm.value;
        const data = await this._visaService.addVisaImportantInformation(formData).toPromise();        
        this.storeFormData.emit(data);
        this.importantInformationForm.markAsPristine();
        this._responseNotificationService.showMessage("Visa Important Information Added Successfully");
        return true;
        
      } catch (error) {
        console.error("Error while adding Important info ", error);
        this._responseNotificationService.showMessage("Failed to add Important Information", true);
        return false;
      }
    }else{
      this.importantInformationForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
      this._globalService.customAlert("Fill all required fields to save", "Invalid Form");
      return false;
    }
    
  }

  async resetForm() {
    if (await this._globalService.confirmActionPopup("Confirm to reset data", "Confirm", "Confirm")) {
      this.ngOnInit();
    }
  }

  goPrevious() {
    this.viewChange.emit(true);
  }

  goNext() {
    this.viewChange.emit(false);
  }

  async saveAndNext(){
    if(await this.onSubmit()){
      this.goNext()
    }
  }

  formDataModified(): boolean {
    return (this.importantInformationForm.dirty || this.importantInformationForm.invalid) && this.importantInformationForm.touched;
  }

}
